const state = () => {
  return {
    participants: {
      user: {
        email: "",
        phone: "",
        user_detail: {}
      },
      preferred_contact_method: "",
      is_hispanic: "",
      password: "",
      confirm_password: "",
      city: "",
      county: "",
      race: [],
      gender: "",
      age: "",
      state: "",
      sex_at_birth: "",
      change_email: false,
      change_phone: false,
      mailing_state:"",
      mailing_city:"",
      mailing_county:"",
      sex_with_ids:[],
      preferred_contact_method_arr: [
        { name: "Email", code: "email" },
        { name: "Text", code: "sms" }
      ],
      is_hispanic_arr: [
        { name: "Yes", id: 1 },
        { name: "No", id: 0 }
      ]
    }
  };
};

export default state;
